import { render, staticRenderFns } from "./RootComponent.vue?vue&type=template&id=276ddbb0&scoped=true"
import script from "./RootComponent.vue?vue&type=script&lang=js"
export * from "./RootComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276ddbb0",
  null
  
)

export default component.exports